import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
});

export const customBaseQuery = async (
  args: any,
  api: any,
  extraOptions: any,
) => {
  const accessToken = Cookies.get('at');

  let adjustedArgs = typeof args === 'string' ? { url: args } : { ...args };

  // Добавляем заголовок Authorization, если accessToken доступен
  if (accessToken) {
    if (!adjustedArgs.headers) {
      adjustedArgs.headers = {};
    }
    adjustedArgs.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  // if (login && password) {
  //   if (adjustedArgs.method === 'GET' || !adjustedArgs.method) {
  //     adjustedArgs.params = {
  //       login,
  //       password,
  //       ...adjustedArgs.params,
  //     };
  //   } else {
  //     adjustedArgs.body = {
  //       Login: login,
  //       Password: password,
  //       ...adjustedArgs.body,
  //     };
  //   }
  // }

  return baseQueryWithAuth(adjustedArgs, api, extraOptions);
};

export const saveToCookies = (key: string, value: string) => {
  Cookies.set(key, value);
};

export const getFromCookies = (key: string) => {
  return Cookies.get(key);
};
